import React, { useContext, useMemo } from "react";
import ViewIcon from "@material-ui/icons/InputOutlined";
import EditIcon from "@material-ui/icons/EditOutlined";
import { OrderIndData, OrderIndListData } from "../../../data/trading/orderIndicative/types";
import { LocalizationContext } from "../../../core/localization/Localization";
import { Action } from "material-table";
import { useHistory } from "react-router-dom";
import { useViewOrderId } from "./DisplayOrderInd";
import { useOrderIndDelete } from "../../../data/trading/orderIndicative/hooks/useOrderIndDelete";
import { getOrderIndEditLocation } from "./Locations";
import { AccessRights } from "../../../core/navigation/types";


export const useOrderIndActions = (userAccessRights: AccessRights) => {
  const { getString } = useContext(LocalizationContext);
  const onShowOrderId = useViewOrderId();
  const onEditOrderId = useEditOrderIndAction();

  return useMemo(() => {
    const result: Action<OrderIndListData>[] = [
      {
        icon: () => <ViewIcon />,
        tooltip: getString("tableShow"),
        onClick: (event, rowData) => onShowOrderId(rowData as OrderIndListData),
      },
      {
        icon: () => <EditIcon />,
        tooltip: getString("tableEdit"),
        onClick: (event, rowData) => onEditOrderId(rowData as OrderIndListData),
        hidden: userAccessRights===AccessRights.ReadOnly
      },
    ];

    return result;
  }, [onShowOrderId, onEditOrderId, getString]);
};

export const useDeleteOrderIndAction = () => {
  const [, deleteOrderId] = useOrderIndDelete();
  return React.useCallback(
    async (orderInd: OrderIndListData) => {
      if (orderInd.orderIndId ) {
        await deleteOrderId(orderInd.orderIndId);
      }
    },
    [deleteOrderId]
  );
};

export const useEditOrderIndAction = () => {
  const history = useHistory();
  return React.useCallback(
    (orderInd: OrderIndListData) => history.push(getOrderIndEditLocation(orderInd.orderIndId)),
    [history]
  );
};
